export const init = () => {
  // Check if container exists & init slider
  const $slickServices = $('.services_holder').find('.services-mask>div');
  if ($slickServices.find('.column').length > 1) {
    $slickServices.slick({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      variableWidth: false,
      edgeFriction: 0,
      useCSS: true,
      useTransform: true,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: cube.constants.breakpointSm,
          settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
          breakpoint: cube.constants.breakpointXs,
          settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    });
  }
};



// WEBPACK FOOTER //
// ./src/homepage/sliders/home-slider-services-header.js